import React from 'react';
import { Link } from 'react-router-dom';
import Sectiontitle from "../components/Sectiontitle";
import Layout from "../components/Layout";
import { PlaystoreApp } from "../components/PlaystoreApp";
import { useLanguage } from '../context/LanguageContext';

function Apps() {
  const { d, lang } = useLanguage();

  return (
    <Layout>
      <div className="mi-service-area mi-section mi-padding-top mi-padding-bottom">
        <div className="container">
          <Sectiontitle title={d.privacy.titles.apps || "Aplicaciones Android"} />
          <div className="mi-service-wrapper">
            <div className="row mt-30-reverse">
              {d.apps && d.apps.map((app, index) => (
                <div className="col-12 mt-30" key={app.title}>
                  <PlaystoreApp
                    itemNumber={index}
                    appId={app.id}
                    title={app.title}
                    subtitle={app.subtitle}
                    details={app.details}
                    link={app.link}
                    buttontxt={app.button}
                    icon={app.icon}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Acceso a Política de Privacidad General de Desarrollador */}
          <div className="mt-5 pt-3 text-center">
            <Link to="/privacy-policy" className="mi-button" style={{ background: "transparent", border: "1px solid rgba(255,255,255,0.2)", color: "#aaa" }}>
              {lang === 'es' ? 'Ver Política de Privacidad General de Desarrollador' : 'View General Developer Privacy Policy'}
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Apps;
